import { Instance } from 'mobx-state-tree';
import { ProjectStopReschedulingDtoModelBase } from './ProjectStopReschedulingDtoModel.base';

/* The TypeScript type of an instance of ProjectStopReschedulingDtoModel */
export interface ProjectStopReschedulingDtoModelType extends Instance<typeof ProjectStopReschedulingDtoModel.Type> {}

/* A graphql query fragment builders for ProjectStopReschedulingDtoModel */
export { selectFromProjectStopReschedulingDto, projectStopReschedulingDtoModelPrimitives, ProjectStopReschedulingDtoModelSelector } from './ProjectStopReschedulingDtoModel.base';

/**
 * ProjectStopReschedulingDtoModel
 *
 * Stop rescheduling
 */
export const ProjectStopReschedulingDtoModel = ProjectStopReschedulingDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
